import { api, unwrap } from "@/lib/api/client";

export interface Me {
  user_id: string;
  tenant_id: string;
  roles: string[];
}

/** Fetch the authenticated principal (authoritative role source). */
export async function fetchMe(): Promise<Me> {
  return unwrap(await api.GET("/api/v1/me"));
}
